import { defineComponent } from "vue";
import ScrollAnimation from "@i22/scroll-animation";
import PictureElement from "./component-library9.mjs";
import { useMappedPropsOptions } from "./component-library152.mjs";
import Paragraph from "./component-library5.mjs";
import Heading from "./component-library6.mjs";
import Badge from "./component-library33.mjs";
const _sfc_main = defineComponent({
  name: "ImageTeaser",
  components: {
    PictureElement,
    Badge,
    Heading,
    Paragraph
  },
  mixins: [
    ScrollAnimation,
    useMappedPropsOptions(Heading, "heading", {
      tag: "h2",
      size: "md"
    })
  ],
  props: {
    background: {
      type: Object,
      default: void 0
    },
    image: {
      type: Object,
      default: void 0
    },
    lazy: { type: Boolean },
    title: { type: String, default: "" },
    description: { type: String, default: "" },
    hasBadge: { type: Boolean },
    teaserHeightXs: { type: String, default: "380px" },
    teaserHeightSm: { type: String, default: "400px" },
    teaserHeightMd: { type: String, default: void 0 },
    teaserHeightLg: { type: String, default: void 0 },
    positionY: {
      type: String,
      default: "",
      validator(value) {
        return ["", "top", "center", "bottom"].includes(value);
      }
    },
    positionYDesktop: {
      type: String,
      default: "",
      validator(value) {
        return ["", "top", "center", "bottom"].includes(value);
      }
    },
    theme: {
      type: String,
      default: void 0,
      validator(value) {
        return ["light", "dark", void 0].includes(value);
      }
    },
    animateTile: { type: Boolean },
    animateImage: { type: Boolean },
    animationDelay: { type: Number, default: 1 },
    animationContent: {
      type: Object,
      default: () => ({
        start: "top bottom",
        end: "top center",
        vars: { yPercent: 20 }
      })
    }
  },
  computed: {
    componentStyles() {
      return {
        [`--teaser-height-xs`]: this.teaserHeightXs,
        [`--teaser-height-sm`]: this.teaserHeightSm,
        [`--teaser-height-md`]: this.teaserHeightMd,
        [`--teaser-height-lg`]: this.teaserHeightLg
      };
    },
    componentClass() {
      const classNames = [];
      if (this.theme)
        classNames.push(`text--${this.theme}`);
      if (this.positionY)
        classNames.push(`image-teaser--${this.positionY}`);
      if (this.positionYDesktop)
        classNames.push(`image-teaser--desktop-${this.positionYDesktop}`);
      return classNames;
    }
  },
  mounted() {
    this.createScrollAnimations();
  },
  methods: {
    createScrollAnimations() {
      if (this.animationContent) {
        this.createScrollTrigger({
          trigger: this.$refs.container,
          start: this.animationContent.start,
          end: this.animationContent.end,
          scrub: 1,
          animation: this.createTweenFrom(this.$refs.container, this.animationContent.vars)
        });
      }
      if (this.animateTile) {
        this.createScrollTrigger({
          trigger: this.$refs.imageTeaser,
          start: "top bottom",
          end: "center-=25% bottom",
          scrub: 1,
          animation: this.createTweenFrom(this.$refs.imageTeaser, {
            yPercent: 15 * this.animationDelay
          })
        });
      }
      if (this.animateImage && this.$refs.imageElement) {
        this.createScrollTrigger({
          trigger: this.$refs.imageElement.$el,
          start: "top bottom",
          end: "center-=25% bottom",
          scrub: 1,
          animation: this.createTweenFrom(this.$refs.imageElement.$el, {
            yPercent: 15 * this.animationDelay
          })
        });
      }
    }
  }
});
export {
  _sfc_main as default
};
